/* SNAPTRAP — personalized products: the sticky bar's native add button is hidden by CSS.
   Here we (1) inject a "Customise now" button that ONLY opens the customizer, and
   (2) as a backup, neutralize any stray event on the native button across all trigger types.
   personalization.js is not modified. */
(function () {
  function isPerso() {
    return !!document.querySelector('[data-perso-gate]');
  }
  function openCustomizer() {
    var t = document.querySelector('.perso-trigger .perso-btn, .perso-trigger button, [data-perso-open]');
    if (t) t.click();
  }

  // (1) Inject our own button AND remove the native add button. Removal is the guarantee:
  //     Horizon adds via a delegated listener that can win a capture-phase race, so blocking the
  //     event isn't reliable — but a button that isn't in the DOM can't be matched or added.
  function inject() {
    if (!isPerso()) return;
    var bar = document.querySelector('.sticky-add-to-cart__bar') || document.querySelector('.sticky-add-to-cart');
    if (!bar) return;
    var native = bar.querySelector('.sticky-add-to-cart__button');
    if (!bar.querySelector('.snap-sticky-customise')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'snap-sticky-customise';
      b.textContent = 'Customise now';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openCustomizer();
      });
      if (native && native.parentNode) {
        native.parentNode.insertBefore(b, native.nextSibling);
      } else {
        bar.appendChild(b);
      }
    }
    if (native) native.remove();
  }

  // Re-run on DOM changes (variant change / late sticky render), coalesced via rAF.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; inject(); });
  }
  if (document.readyState !== 'loading') inject();
  document.addEventListener('DOMContentLoaded', inject);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  // (2) Backup: block the native sticky button on every event Horizon could bind.
  ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'click', 'submit'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!isPerso()) return;
      var el = e.target;
      var native = el.closest && el.closest('.sticky-add-to-cart__button');
      var inSticky = el.closest && el.closest('.sticky-add-to-cart');
      if (type === 'submit') {
        if (inSticky) { e.preventDefault(); e.stopImmediatePropagation(); }
        return;
      }
      if (native) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (type === 'click') openCustomizer();
      }
    }, true);
  });
})();
